import React, {useState, useEffect} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Button} from "primereact/button";
import axios from "axios";
import Cookies from "js-cookie";
import moment from "moment";

import HelpComponent from "../HelpComponent";

const OperatorShowComponent = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {id, action, entity} = useParams();
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (id) {
      setLoading(true)
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "operator-data/" + id,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setLoading(false)
          setFormData(response.data.data);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false)
        })
    }
  }, [])

  return (
    <>
      <div className={"p-grid p-mt-3"}>
        <div className={"p-col p-col-align-center"}>
          <h2 className={"p-m-0"}>
        {formData.company_name}
          </h2>
        </div>
        <div className={"p-col p-text-right p-col-align-center"}>
          <Button type="button"
                  icon={"pi pi-pencil"}
                  onClick={() => {
                    navigate('/operator/update/' + id)
                  }}
                  className="p-button-warning p-ml-2">
          </Button>
          <Button type="button"
                  icon={"pi pi-times"}
                  onClick={() => {
                    navigate(-1)
                  }}
                  className="p-button-secondary close p-ml-2">
          </Button>
        </div>
      </div>
      <div className={"p-grid"}>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('created_at')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {moment.utc(formData.created_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}
          </p>
        </div>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('updated_at')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {moment.utc(formData.updated_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}
          </p>
        </div>
      </div>
      <Panel className={"p-mt-3"}>
        {/*<HelpComponent type={"site"} position={"IN_ACTIVE_BOX"}/>*/}
        <HelpComponent type={"show_box"}/>
        <div className={"p-grid"}>
          <div className={"p-col-12 p-lg-6"}>
            <div className="p-field p-fluid">
              <label htmlFor="tax_number">{t('tax_number')}</label>
              <span className="p-d-block p-text-bold">
                {formData.tax_number}
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-6"}>
            <div className="p-field p-fluid">
              <label htmlFor="address">{t('address')}</label>
              <span className="p-d-block p-text-bold">
                {formData.zip_code} {formData.registered_office_city}, {formData.street_and_house_number}
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-6"}>
            <div className="p-field p-fluid">
              <label htmlFor="bank_name">{t('bank_name')}</label>
              <span className="p-d-block p-text-bold">
                {formData.bank_name}
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-6"}>
            <div className="p-field p-fluid">
              <label htmlFor="bank_account_number">{t('bank_account_number')}</label>
              <span className="p-d-block p-text-bold">
                {formData.bank_account_number}
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-6"}>
            <div className="p-field p-fluid">
              <label htmlFor="contact_email">{t('contact_email')}</label>
              <span className="p-d-block p-text-bold">
                {formData.contact_email}
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-2"}>
            <div className="p-field p-fluid">
              <label htmlFor="vat_payment">{t('vat_payment')}</label>
              <span className="p-d-block p-text-bold">
                {t(formData?.vat_payment?.toString()?.toLowerCase())}
              </span>
            </div>
          </div>
        </div>
        <hr className={"p-mt-3 p-mb-5"}/>
        <h3>{t('billing_integration')}</h3>
        <div className={"p-grid"}>
          <div className={"p-col-12 p-lg-6"}>
            <div className="p-field p-fluid">
              <label htmlFor="billing_integration">{t('billing_integration_name')}</label>
              <span className="p-d-block p-text-bold">
                {t(formData?.billing_integration?.toLowerCase())}
              </span>
            </div>
          </div>
          {formData.billing_integration === 'számlázz.hu' &&
            <>
              <div className={"p-col-12 p-lg-12"}>
                <div className="p-field p-fluid">
                  <label htmlFor="szamlazz_hu_agent_code">{t('szamlazz_hu_agent_code')}</label>
                  <span className="p-d-block p-text-bold">
                {formData.szamlazz_hu_agent_code}
              </span>
                </div>
              </div>
            </>
          }
          {formData.billing_integration === 'Billingo' &&
            <>
              <div className={"p-col-12 p-lg-8"}>
                <div className="p-field p-fluid">
                  <label htmlFor="billingo_api_key">{t('billingo_api_key')}</label>
                  <span className="p-d-block p-text-bold">
                {formData.billingo_api_key}
              </span>
                </div>
              </div>
              <div className={"p-col-12 p-lg-4"}>
                <div className="p-field p-fluid">
                  <label htmlFor="billingo_block_id">{t('billingo_block_id')}</label>
                  <span className="p-d-block p-text-bold">
                {formData.billingo_block_id}
              </span>
                </div>
              </div>
              <div className={"p-col-12 p-lg-4"}>
                <div className="p-field p-fluid">
                  <label htmlFor="billingo_bank_account_id">{t('billingo_bank_account_id')}</label>
                  <span className="p-d-block p-text-bold">
                {formData.billingo_bank_account_id}
              </span>
                </div>
              </div>
            </>
          }
        </div>
      </Panel>
    </>
  )
}
export default withTranslation('common')(OperatorShowComponent);
